import type { Conversation } from "../types/messaging.types.ts"

/**
 * Unread badges, derived from the conversation rows rather than counted twice.
 *
 * The rows are the single source: the socket seeds them on connect from the
 * server's persisted read markers, a `read_state` frame corrects one of them
 * after a read, and an arriving message bumps one. Summing them means the
 * navigation badge cannot drift away from the per-conversation badges beside
 * it — which a separate running total eventually does, because every path that
 * forgets to adjust it leaves it wrong until the next reconnect.
 *
 * Only conversations the caller currently holds are summed, and the portal's
 * list holds only the customer's own project conversations, so an internal
 * room can never reach this number.
 */
export const unreadTotalOf = (conversations: Conversation[]): number =>
  conversations.reduce((total, row) => total + (row.unread_count || 0), 0)

/** `99+` past two digits, so the badge cannot widen the control it sits on. */
export const BADGE_OVERFLOW = 99
